
import Dedication from "../../../assets/Dedication.png";
import Innovation from '../../../assets/Innovation.png'
import Efficiency from '../../../assets/Efficiency.png'
import Empowerment from '../../../assets/Empowerment.png'
import Teamwork from '../../../assets/Teamwork.png'


const data = [
    {
        icon: Dedication,
        title: "Dedication",
        description:
            "We are driven by a deep passion for empowering learners through technology. At SAN LMS, we strive to make quality education accessible, practical, and impactful for every student and professional.",
    },
    {
        icon: Innovation,
        title: "Innovation",
        description:
            "We continuously refine and update our programs to align with evolving industry standards and emerging technologies, ensuring our learners remain competitive in a rapidly advancing digital landscape.",
    },
    {
        icon: Efficiency,
        title: "Efficiency",
        description:
            "We break down complex concepts into practical, well-organized modules that enable learners to master new skills efficiently and with confidence. Learning should be structured and clear.",
    },
    {
        icon: Empowerment,
        title: "Empowerment",
        description:
            "We break down complex concepts into practical, well-organized modules that enable learners to master new skills efficiently and with confidence. Learning should be structured and clear.",
    },
    {
        icon: Teamwork,
        title: "Teamwork",
        description:
            "We break down complex concepts into practical, well-organized modules that enable learners to master new skills efficiently and with confidence. Learning should be structured and clear.",
    },
];

export const LearnersChoose = () => {
    return (
        <section className="overflow-hidden py-14 bg-gray-50">
            <div className="w-full max-w-7xl mx-auto px-4 overflow-x-hidden overflow-y-hidden space-y-6 ">
                 <div>
                    {/* Title */}
                    <h1 className="text-primary-800 text-[24px] sm:text-[35px] md:text-[45px] font-bold text-center">
                        Why SAN LMS ?
                    </h1>

                    {/* Description */}
                    <p className=" text-center  mx-auto text-lg">
                        Designed for better learning.Built for real success
                    </p>
                 </div>
                <div className="relative w-max mx-auto">
                    <div className="flex gap-10 animate-scroll hover:[animation-play-state:paused]">

                    {[...data, ...data].map((item, index) => (
                        <div
                            key={index}
                            className="group relative w-[450px] pt-16 transition-all duration-500"
                        >

                            {/* Icon */}
                            <div className="absolute top-5 left-1/2 -translate-x-1/2 z-20
                  w-28 h-28 sm:w-32 sm:h-32 rounded-full
                  flex items-center justify-center
                  border shadow-xl
                  transition-all duration-500
                  group-hover:border-primary-600 
                  group-hover:-rotate-6 
                  group-hover:scale-125">

                                <img src={item?.icon} alt="icon" className="w-13 h-12 sm:w-16 sm:h-15" />
                            </div>

                            {/* Card */}
                            <div className="relative bg-white rounded-3xl 
                pt-20 sm:pt-24 pb-16 px-10 text-center 
                group-hover:border-primary-600
                 h-[250px] sm:h-[300px] flex flex-col">

                                <div className="absolute -top-14 left-1/2 -translate-x-1/2 
                  w-40 h-40 bg-gray-50 rounded-full z-0"></div>

                                <h3 className="text-xl sm:text-3xl mt-3 sm:mt-4 font-semibold text-blue-700 mb-3 sm:mb-6 relative z-10">
                                    {item.title}
                                </h3>

                                <p className="text-md text-gray-700 leading-relaxed relative z-10 text-start">
                                    {item.description}
                                </p>

                            </div>
                        </div>
                    ))}
                </div>
            </div>
            </div>
        </section>
    );
};